module.exports = __webpack_public_path__ + "static/media/mira_logo_animation_sequence (1).aeac9bb5.png";